import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {UiSlot} from '@api/components'
import {Switcher} from '@components/common/base/switcher'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import {useSyncEventUpdateEffect} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {TwTitle} from './containers'
import DarkIcon from './icons/icon-dark.svg'
import LightIcon from './icons/icon-light.svg'
import StyleIcon from './icons/icon-style.svg'
import {useSystemAppearanceStore} from './system-appearance-store'

const TwIcon = tw.div<{$current: boolean}>`
  cursor-pointer
  rounded-8
  w-64
  h-48
  ${p =>
    cn(
      p.$current &&
        cn('outline', 'outline-solid', 'outline-4', 'outline-accent-old')
    )}
`

export const ChooseColorScheme = observer(() => {
  useSyncEventUpdateEffect('profile', {
    debounceTime: 50,
    filter: globals.currentUserId
  })
  const [state, store] = useSystemAppearanceStore()
  const options =
    state.currentTheme === 'light'
      ? [
          {label: Lang.msg.profilePage.themeVariationNone, value: 'none'},
          {label: Lang.msg.profilePage.themeVariationAuto, value: 'auto'},
          {label: Lang.msg.profilePage.themeVariationLighter, value: 'lighter'},
          {label: Lang.msg.profilePage.themeVariationDarker, value: 'darker'}
        ]
      : [
          {label: Lang.msg.profilePage.themeVariationNone, value: 'none'},
          {label: Lang.msg.profilePage.themeVariationTransparent, value: 'auto'}
        ]
  return (
    <div className="flex flex-col">
      <TwTitle className="mb-8">
        <div className="flex mr-4 text-primary">
          <StyleIcon />
        </div>
        {Lang.msg.profilePage.chooseColorScheme}:
      </TwTitle>
      <div className="flex ml-28 w-fit gap-48">
        <TwIcon $current={state.currentTheme === 'dark'}>
          <DarkIcon onClick={() => store.applyTheme('dark')} />
        </TwIcon>
        <TwIcon $current={state.currentTheme === 'light'}>
          <LightIcon onClick={() => store.applyTheme('light')} />
        </TwIcon>
      </div>
      <div className="mt-24 ml-28 flex gap-32 items-center text-sm-regular text-interactive-old">
        <span>{Lang.msg.profilePage.themeVariation}:</span>
        <DropdownList
          className="flex-1 w-172"
          initialOpen={false}
          options={options}
          value={state.themeVariation[state.currentTheme]}
          onChange={store.setThemeVariation}
        />
      </div>
      <div className="mt-24 ml-28 flex gap-32 items-center text-sm-regular text-interactive-old">
        <span>{Lang.msg.profilePage.turnOnColumnColor}:</span>
        <Switcher
          active={state.columnColorEnabled}
          onClick={store.toggleColumnColor}
        />
      </div>
      <UiSlot name="system-appearance-color-scheme-after" />
    </div>
  )
})
